import { HeroSection } from '../components/HeroSection';
import { TrustAuthoritySection } from '../components/TrustAuthoritySection';
import { CorePracticeAreasSection } from '../components/CorePracticeAreasSection';
import { ExpressServicesSection } from '../components/ExpressServicesSection';
import { WhyClientsChooseUsSection } from '../components/WhyClientsChooseUsSection';
import { HowWeWorkSection } from '../components/HowWeWorkSection';
// import { JurisdictionFocusSection } from '../components/JurisdictionFocusSection';
// import { LeadershipTeamSection } from '../components/LeadershipTeamSection';
import { ClientTestimonialsSection } from '../components/ClientTestimonialsSection';
import { ClientManagementSection } from '../components/ClientManagementSection';
import { CTASection } from '../components/CTASection';
import { Faq} from "../components/Faq"
// import { FAQPage} from "../components/FAQPage"
// import GoogleReviews from './GoogleReviews';
// import { Blogs} from '../blogs/Blogs';

// import {Blogs} from "../blogs/Blogs"

export const HomePage = () => {
  return (
    <>
      <HeroSection />
      <TrustAuthoritySection />
      <ExpressServicesSection />
      <CorePracticeAreasSection />
      <WhyClientsChooseUsSection />
      <ClientManagementSection />
      {/* <HowWeWorkSection /> */}
      {/* <JurisdictionFocusSection /> */}
      {/* <LeadershipTeamSection /> */}
      <ClientTestimonialsSection />
      {/* <Blogs/> */}
      {/* <Blogs/> */}
      {/* <div>
        <GoogleReviews />
      </div> */}
      <CTASection />
      <Faq/>
    </>
  );
};